export const AUTHOR_TYPE_AUTOR = 'autor'
export const AUTHOR_TYPE_CO_ORIENTADOR = 'co_orientador'
export const AUTHOR_TYPE_ORIENTADOR = 'orientador'

export const EVALUATION_TYPE_WEB = 'avaliacao_web'
export const EVALUATION_TYPE_INLOCO = 'avaliacao_inloco'

export const MODALITY_AVALIADOR = 'avaliador'
export const MODALITY_PARTICIPANTE = 'participante'
export const MODALITY_EVENTO_PRINCIPAL = 'evento_principal'
export const MODALITY_PROFISSIONAL = 'profissional'
export const MODALITY_PROPONENTE = 'proponente'

export const PAPER_STATUS_ACEITO = 'aceito'
export const PAPER_STATUS_AGUARDANDO_PUBLICACAO = 'aguardando_publicacao'
export const PAPER_STATUS_APROVADO_TRIAGEM = 'aprovado_pela_triagem'
export const PAPER_STATUS_ATRIBUIDO = 'atribuido'
export const PAPER_STATUS_AVALIADO = 'avaliado'
export const PAPER_STATUS_CANCELADO = 'cancelado'
export const PAPER_STATUS_EM_AVALIACAO = 'em_avaliacao'
export const PAPER_STATUS_FINALIZADO = 'finalizado'
export const PAPER_STATUS_NAO_DESIGNADO = 'nao_designado'
export const PAPER_STATUS_NOTIFICADO = 'notificado'
export const PAPER_STATUS_PUBLICADO = 'publicado'
export const PAPER_STATUS_REJEITADO = 'rejeitado'
export const REGISTRATION_REPROVADO = 'reprovado'
export const REGISTRATION_REPROVADO_TRIAGEM = 'reprovado_pela_triagem'
export const REGISTRATION_SUBSTITUIDO = 'substituido'



// WEBPACK FOOTER //
// ./src/app/types.js